import { useEffect, useRef, useState } from 'react'

import { notifyMethod } from '../../../App'
import useRedux from '../../../hooks/useRedux'
import useRouter from '../../../hooks/useRouter'
import { profileDetails } from '../../../redux/user_management/reducer'
import { USER_TXT } from '../../../routing/pathName.constant'
import { useFormFn } from '../../../shared/antd/ANTDForm'
import { getBase64 } from '../../../utils'
import configData from '../../../utils/config'
import { childUsers, userWiseRole } from '../../../utils/constant'
import { formatDate } from '../../../utils/dayjs'
import debounce from '../../../utils/debounce'
import {
  entries,
  include,
  isArray,
  isEqual,
  keys,
  length,
  notEqual,
  ternary,
} from '../../../utils/javascript'
import { getItem, setItem } from '../../../utils/localstorage'
import { getImageFileApi } from '../../jobs/jobs.api'
import { userChildrenList } from '../../layout/sidebar.description'
import { cityOptions, pincodeOptions, stateOptions } from '../addressData'
import LocationChannel from '../presentation/LocationChannel'
import LocationCollectionCenter from '../presentation/LocationCollectionCenter'
import { VehicleModelListUserForm } from '../presentation/VehicleModelList'
import {
  addNewBuildingApi,
  addNewUserApi,
  getTagListApi,
  getUserList,
  getUserProfileApi,
  updateBuildingApi,
  updateUserApi,
  userValidationApi,
} from '../user.api'
import {
  childUserFormFields,
  refurbisherMachineFields,
  refurbisherMachineTitle,
  roleIdByPath,
  userFormByRoleId,
  userFormFields,
} from '../user.description'

const addUser = ({
  t,
  editInfo,
  setEditInfo,
  isBuilding,
  selectedUserDetails,
  handleCancelEdit,
  isProfile,
  userRoleId,
  apiCall,
  addNewBuildData,
  successCallback,
}) => {
  const form = useFormFn()
  const { params, navigate, location } = useRouter()
  const { dispatch } = useRedux()
  const { country } = configData
  const {
    admin,
    site,
    consumer,
    recycler,
    refurbisher,
    dealer,
    producer,
    superUser,
    scrappingFacilityManager,
    dataEntry,
    categoryUser,
    salesUser,
    operationsUser,
    scrappingFacilityEntryUser,
    supplier,
    collectionCenter,
  } = userWiseRole
  const userType = params?.userType
  const formRoleId = ternary(
    isBuilding,
    site,
    roleIdByPath[userType] ?? userRoleId ?? editInfo?.data?.roleId,
  )
  const [selectUser, setSelectUser] = useState({
    flag: false,
    data: {},
    list: {},
  })
  const [loader, setLoader] = useState(false)
  const [popup, setPopup] = useState({ open: false, message: '' })
  const userDetails = JSON.parse(getItem('userData'))
  const { roleId, id: loginUserId } = { ...userDetails }
  const formField =
    userFormByRoleId[formRoleId] ||
    (include(childUsers, formRoleId) ? childUserFormFields : userFormFields)

  const [userForm, setUserForm] = useState(
    JSON.parse(JSON.stringify(formField)),
  )
  const initialEditData = useRef({})
  const [refurbisherOpt, setRefurbisherOpt] = useState({
    materialType: [],
    machineType: [],
    energyType: [],
    jobTag: [],
  })
  const [currentAddress, setCurrentAddress] = useState('')

  const userWiseDepartment = {
    [dataEntry]: 'ACCOUNTING',
    [categoryUser]: 'ACCOUNTING',
    [salesUser]: 'SALES',
    [operationsUser]: 'OPERATIONS',
    [scrappingFacilityEntryUser]: 'OPERATIONS',
  }

  useEffect(() => {
    if (currentUserDescription?.parent) {
      async function fetchData() {
        setLoader(true)
        const responseData = await getUsers({ page: 1 })
        setLoader(false)
        setSelectUser({
          ...selectUser,
          data: responseData?.list?.[0] || {},
          list: responseData,
        })
        if (include(childUsers, formRoleId) && !editInfo?.data?.id) {
          handleSameAsParent(responseData?.list?.[0])
        }
      }
      if (isEqual(currentUserDescription?.parent?.id, roleId)) {
        setSelectUser(prev => ({ ...prev, data: userDetails }))
        if (include(childUsers, formRoleId) && !editInfo?.data?.id) {
          handleSameAsParent(userDetails)
        }
      } else {
        fetchData()
      }
    }
    // if (isEqual(consumer, formRoleId)) {
    //   setCustomerTagsOpt()
    // }
    if (
      include(
        [
          superUser,
          dataEntry,
          categoryUser,
          salesUser,
          operationsUser,
          scrappingFacilityEntryUser,
        ],
        formRoleId,
      )
    ) {
      setUserForm(prev => ({
        ...prev,
        departmentName: {
          ...prev?.departmentName,
          required: true,
          hidden: false,
          disabled:
            include(
              [
                dataEntry,
                categoryUser,
                salesUser,
                operationsUser,
                scrappingFacilityEntryUser,
              ],
              formRoleId,
            ) || editInfo?.data?.id,
        },
      }))
    }
    if (include([refurbisher, supplier], formRoleId)) {
      setRefurbisherMachineOpt()
      setUserForm(prev => ({
        ...prev,
        materialProducerMaterialTypes: {
          ...prev?.materialProducerMaterialTypes,
          onSearch: onMaterialSearch,
        },
      }))
    }

    if (isEqual(formRoleId, dealer)) {
      setUserForm(prev => {
        const clonedForm = { ...prev }
        clonedForm.locationChannelRequestDtos = {
          xs: 24,
          render: fieldName => <LocationChannel {...{ fieldName }} />,
        }
        return clonedForm
      })
    }
    if (isEqual(formRoleId, collectionCenter)) {
      setUserForm(prev => {
        const clonedForm = { ...prev }
        clonedForm.locationChannelRequestDtos = {
          xs: 24,
          render: fieldName => <LocationCollectionCenter {...{ fieldName }} />,
        }
        return clonedForm
      })
    }
    if (isEqual(formRoleId, producer)) {
      setUserForm(prev => {
        const clonedForm = { ...prev }
        clonedForm.modelNames = {
          xs: 24,
          render: fieldName => (
            <VehicleModelListUserForm
              modelList={editInfo?.data?.modelDtos}
              onSaveModel={modelNames => {
                form.setFieldsValue({ modelNames })
              }}
              onDeleteModel={id => {
                form.setFieldsValue({
                  modelIds: [...(form.getFieldValue('modelIds') || []), id],
                })
              }}
            />
          ),
        }
        return clonedForm
      })
    }
  }, [])

  useEffect(() => {
    if (editInfo?.data?.id) {
      const getEmailList = data => {
        const emailList = []
        entries(data)?.forEach(([key, value]) => {
          if (include(key, 'emailId') && value) {
            emailList.push(value)
          }
        })
        return ternary(length(emailList), emailList, [''])
      }
      const modifyFileKeys = file =>
        ternary(
          file?.fileUrl,
          {
            fileList: [
              { name: file?.fileName, url: file?.fileUrl, uid: file?.dmsId },
            ],
          },
          null,
        )
      const setFormData = (formFields, data = {}) => {
        const formValues = {}
        const mapToData = fields => {
          entries(fields)?.forEach(([key, value]) => {
            if (value?.child) return mapToData(value?.child)
            const fieldValue = data[key]
            if (isEqual('dateTimePicker', value?.inputType)) {
              formValues[key] = formatDate(fieldValue, 'DD/MM/YYYY')
            } else if (isEqual('timePicker', value?.inputType)) {
              formValues[key] = formatDate(fieldValue, value?.format)
            } else if (isEqual('formUpload', value?.inputType)) {
              formValues[key] = modifyFileKeys(fieldValue)
            } else if (isEqual('emailId', key)) {
              formValues[key] = getEmailList(data)
            } else if (include(['consumerType'], key)) {
              formValues.consumerType = data.company
                ? 'company'
                : data?.individual
                  ? 'individual'
                  : ''
            } else if (include(['inchargeEmail', 'inchargePhone'], key)) {
              formValues[key] = data.inchargeDetails?.[key] ?? ''
              // } else if (isEqual('consumerTags', key)) {
              //   formValues.consumerTags = fieldValue?.map(({ id }) => id)
            } else if (include(['displayName'], key)) {
              formValues[key] = data.displayName ?? 'RVSF'
            } else if (isEqual('materialProducerMaterialTypes', key)) {
              formValues.materialProducerMaterialTypes = isArray(
                data?.materialTypes,
              )
                ? data.materialTypes?.[0]?.materialTypeId
                : null
            } else if (isEqual('machineDetails', key)) {
              if (isArray(data?.materialTypes) && length(data?.materialTypes)) {
                const {
                  machineEnergyKey,
                  machineTypeKey,
                  materialTypeKey,
                  materialTypeId,
                  ...restValues
                } = data.materialTypes[0]
                if (!formValues.machineDetails) formValues.machineDetails = {}
                formValues.machineDetails[materialTypeId] = restValues
              }
            } else if (isEqual('otherDoableJobs', key)) {
              formValues[key] = data?.otherDoableJobTags?.map(item => item?.key)
            } else if (isEqual('locationChannelRequestDtos', key)) {
              const locationChannelRequestDtos = []
              data?.userLocationChannelDtos?.forEach(item => {
                locationChannelRequestDtos.push({
                  stateId: item.stateId,
                  locationId: item?.locationId,
                  channelIds: item?.channels?.map(
                    channel => channel?.channelId,
                  ),
                })
              })
              formValues[key] = locationChannelRequestDtos
            } else {
              formValues[key] = fieldValue
            }
          })
        }
        mapToData(formFields)
        return formValues
      }

      const formData = setFormData(userForm, editInfo?.data)
      form.setFieldsValue(formData)
      initialEditData.current = {
        ...formData,
        materialProducerMaterialTypes: editInfo?.data?.materialTypes,
      }
      setUserForm(prevForm => {
        const { username, password, ...editForm } = prevForm || {}
        if (editForm.certificateNumber && editForm.certificateDetails) {
          const showCert =
            formData?.recyclerRvsfCertification ||
            formData?.producerCpcbCertification
          editForm.certificateNumber.hidden = !showCert
          editForm.certificateDetails.hidden = !showCert
        }
        if (editForm.machineDetails && formData.machineDetails) {
          editForm.machineDetails.child = [
            editInfo?.data?.materialTypes?.[0],
          ]?.reduce((init, item) => {
            const titleKey = refurbisherMachineTitle[item?.materialTypeKey]
            const cloneRefurbisherMachineFields = JSON.parse(
              JSON.stringify(refurbisherMachineFields),
            )
            if (isEqual(item?.materialTypeKey, 'job_Plastic')) {
              cloneRefurbisherMachineFields.machineTypeId.required = false
              cloneRefurbisherMachineFields.machineEnergyId.required = false
              cloneRefurbisherMachineFields.capacity.required = false
            }
            const machineDetails = {
              title: titleKey,
              child: cloneRefurbisherMachineFields,
            }

            init[item?.materialTypeId] = machineDetails
            return init
          }, {})
        }
        if (editForm.materialProducerMaterialTypes) {
          editForm.materialProducerMaterialTypes = {
            ...editForm.materialProducerMaterialTypes,
            disabled: true,
          }
        }
        return editForm
      })
    }
  }, [editInfo])

  useEffect(() => {
    if (include(childUsers, formRoleId) && selectUser?.data?.id) {
      //Add same as parent button
      handleSameAsParent(selectUser?.data)
      setUserForm(prev => {
        const updatedFormField = { ...prev }
        updatedFormField.sameAsParentBtn = {
          ...updatedFormField.sameAsParentBtn,
          hidden: false,
          children: t('btn_SameAsParent'),
          onClick: () => handleSameAsParent(selectUser?.data),
        }
        return updatedFormField
      })
    }
  }, [selectUser?.data])

  const currentUserDescription = userChildrenList.find(item =>
    isEqual(item?.userId, formRoleId),
  )
  const selectPermission = {
    [superUser]: [recycler],
    [dataEntry]: [recycler, scrappingFacilityManager],
    [operationsUser]: [recycler, scrappingFacilityManager],
    [salesUser]: [recycler, scrappingFacilityManager],
    [categoryUser]: [recycler, scrappingFacilityManager],
    [scrappingFacilityEntryUser]: [recycler, scrappingFacilityManager],
  }
  const isSelect =
    isEqual(roleId, admin) || selectPermission[formRoleId]?.includes(roleId)

  const mapToOption = list =>
    list?.map(({ key, id }) => ({
      label: key,
      value: id,
    })) || []

  const onMaterialSearch = debounce((value, options = []) => {
    const filterOption = options?.filter(opt =>
      t(opt?.key)?.toLowerCase()?.startsWith(value?.trim()?.toLowerCase()),
    )
    setUserForm(preForm => {
      const updateForm = { ...preForm }
      updateForm.materialProducerMaterialTypes.options =
        mapToOption(filterOption)
      return updateForm
    })
  }, 300)

  // const setCustomerTagsOpt = async () => {
  //   // tag api call
  //   const resp = await getTagListApi({ params: { type: 'TAG' } })

  //   //update add tag list in option
  //   const customerTagOpt = mapToOption(resp.data?.list)
  //   setUserForm(preForm => {
  //     const updateForm = { ...preForm }
  //     updateForm.consumerTags.options = customerTagOpt
  //     return updateForm
  //   })
  // }

  const setRefurbisherMachineOpt = async () => {
    const [materialResp, machineResp, energyResp, jobTagResp] =
      await Promise.all([
        getTagListApi({ params: { type: 'MATERIAL_TYPE' } }),
        getTagListApi({ params: { type: 'MACHINE_TYPE' } }),
        getTagListApi({ params: { type: 'MACHINE_ENERGY' } }),
        getTagListApi({ params: { type: 'JOB' } }),
      ])

    setUserForm(preForm => {
      const updateForm = { ...preForm }
      updateForm.materialProducerMaterialTypes.options = mapToOption(
        materialResp?.data?.list,
      )
      updateForm.materialProducerMaterialTypes.filterOption = false
      updateForm.materialProducerMaterialTypes.onSearch = val =>
        onMaterialSearch(val, materialResp?.data?.list)
      updateForm.materialProducerMaterialTypes.onBlur = () =>
        onMaterialSearch('', materialResp?.data?.list)
      return updateForm
    })

    setRefurbisherOpt({
      materialType: materialResp?.data?.list,
      machineType: machineResp?.data?.list,
      energyType: energyResp?.data?.list,
      jobTag: jobTagResp?.data?.list,
    })
    refurbisherMachineFields.machineTypeId.options = mapToOption(
      machineResp?.data?.list,
    )
    refurbisherMachineFields.machineEnergyId.options = mapToOption(
      energyResp?.data?.list,
    )
  }

  const businessNameCheck = debounce(async businessName => {
    const params = `?type=BUSINESSNAME&country=${country}&value=${businessName}`
    const response = await userValidationApi({ params })
    if (!response?.data?.success) {
      setPopup({ open: true, message: response?.error?.errorMsg })
    }
  }, 400)

  const handleValuesChange = (val, data) => {
    const updatedForm = { ...userForm }

    // let parentKey
    let currentKey
    let e
    entries(val).forEach(([k, v]) => {
      if (v && isEqual(typeof v, 'object')) {
        // parentKey = k
        currentKey = keys(v)?.at(0)
        e = v
      } else {
        currentKey = k
        e = val
      }
    })
    const updatedFormData = { ...data }
    // const formData = ternary(
    //   parentKey,
    //   updatedFormData?.[parentKey],
    //   updatedFormData,
    // )

    // const tempAddressAttr = ternary(
    //   parentKey,
    //   updatedForm?.[parentKey]?.child,
    //   updatedForm,
    // )
    // if (isEqual(currentKey, 'pincode') && !e?.pincode) {
    //   formData.city = null
    //   formData.state = null
    //   formData.country = null
    //   tempAddressAttr.state.options = stateOptions
    //   tempAddressAttr.city.options = cityOptions
    //   tempAddressAttr.pincode.options = pincodeOptions
    // }
    // if (e?.pincode) {
    //   entries(countryData).some(([countryKey, stateObj]) =>
    //     entries(stateObj).some(([stateKey, cityObj]) =>
    //       entries(cityObj).some(([cityKey, pinArr]) => {
    //         if (!include(pinArr, e.pincode)) return false
    //         if (!formData.country) {
    //           formData.country = countryKey
    //         }
    //         if (!formData.state) {
    //           formData.state = stateKey
    //           tempAddressAttr.state.options = keys(stateObj)?.map(v => ({
    //             label: v,
    //             value: v,
    //           }))
    //         }
    //         if (!formData.city) {
    //           formData.city = cityKey
    //           tempAddressAttr.city.options = keys(cityObj)?.map(v => ({
    //             label: v,
    //             value: v,
    //           }))
    //         }

    //         tempAddressAttr.pincode.options = pinArr?.map(v => ({
    //           label: v,
    //           value: v,
    //         }))
    //         return true
    //       }),
    //     ),
    //   )
    // }
    // if (e?.state) {
    //   entries(countryData).some(([countryKey, stateObj]) =>
    //     entries(stateObj).some(([stateKey, cityObj]) => {
    //       if (notEqual(stateKey, e?.state)) return false
    //       if (!formData.country) {
    //         formData.country = countryKey
    //       }
    //       formData.state = stateKey
    //       const stateOpt = keys(stateObj)?.map(v => ({
    //         label: v,
    //         value: v,
    //       }))
    //       const cityOpt = keys(cityObj)?.map(v => ({
    //         label: v,
    //         value: v,
    //       }))
    //       formData.city = cityOpt?.at(0)?.value
    //       const pincodeOpt = cityObj?.[formData.city]?.map(pin => ({
    //         label: pin,
    //         value: pin,
    //       }))
    //       formData.pincode = pincodeOpt?.at(0)?.value

    //       tempAddressAttr.state.options = stateOpt
    //       tempAddressAttr.city.options = cityOpt
    //       tempAddressAttr.pincode.options = pincodeOpt
    //       return true
    //     }),
    //   )
    // }
    // if (e?.city) {
    //   entries(countryData).some(([countryKey, stateObj]) =>
    //     entries(stateObj).some(([stateKey, cityObj]) =>
    //       entries(cityObj).some(([cityKey, pinArr]) => {
    //         if (notEqual(cityKey, e?.city)) return false
    //         if (!formData.country) {
    //           formData.country = countryKey
    //         }
    //         if (!formData.state) {
    //           formData.state = stateKey
    //           tempAddressAttr.state.options = keys(stateObj)?.map(v => ({
    //             label: v,
    //             value: v,
    //           }))
    //         }
    //         formData.city = cityKey
    //         tempAddressAttr.city.options = keys(cityObj)?.map(v => ({
    //           label: v,
    //           value: v,
    //         }))
    //         const pincodeOpt = pinArr?.map(pin => ({
    //           label: pin,
    //           value: pin,
    //         }))
    //         formData.pincode = pincodeOpt.at(0)?.value
    //         tempAddressAttr.pincode.options = pincodeOpt
    //         return true
    //       }),
    //     ),
    //   )
    // }
    // if (e?.country) {
    //   entries(countryData).some(([countryKey, stateObj]) => {
    //     if (notEqual(countryKey, e?.country)) return false
    //     formData.country = countryKey
    //     const stateOpt = keys(stateObj)?.map(v => ({
    //       label: v,
    //       value: v,
    //     }))
    //     formData.state = stateOpt?.at(0)?.value
    //     const cityOpt = keys(stateObj?.[formData?.state])?.map(v => ({
    //       label: v,
    //       value: v,
    //     }))
    //     formData.city = cityOpt?.at(0)?.value
    //     const pincodeOpt = stateObj?.[formData?.state]?.[formData?.city]?.map(
    //       pin => ({
    //         label: pin,
    //         value: pin,
    //       }),
    //     )
    //     formData.pincode = pincodeOpt?.at(0)?.value
    //     tempAddressAttr.state.options = stateOpt
    //     tempAddressAttr.city.options = cityOpt
    //     tempAddressAttr.pincode.options = pincodeOpt
    //     return true
    //   })
    // }
    if (val?.materialProducerMaterialTypes) {
      if (isEqual(refurbisher, formRoleId)) {
        updatedForm.machineDetails.child = [
          val?.materialProducerMaterialTypes,
        ]?.reduce((init, item) => {
          const titleKey = refurbisherOpt.materialType.find(opt =>
            isEqual(opt?.id, item),
          )?.key
          const cloneRefurbisherMachineFields = JSON.parse(
            JSON.stringify(refurbisherMachineFields),
          )
          const plasticId = refurbisherOpt.materialType.find(opt =>
            isEqual(opt?.key, 'job_Plastic'),
          )?.id
          if (isEqual(plasticId, item)) {
            cloneRefurbisherMachineFields.machineTypeId.required = false
            cloneRefurbisherMachineFields.machineEnergyId.required = false
            cloneRefurbisherMachineFields.capacity.required = false
          }
          const machineDetails = {
            title: refurbisherMachineTitle[titleKey],
            child: cloneRefurbisherMachineFields,
          }

          init[item] = machineDetails
          return init
        }, {})
      }
    }
    if (
      //key is equal to recyclerRvsfCertification
      include(
        ['recyclerRvsfCertification', 'producerCpcbCertification'],
        currentKey,
      ) &&
      length(keys(updatedForm.certificateNumber)) &&
      length(keys(updatedForm.certificateDetails))
    ) {
      const showCert =
        val?.recyclerRvsfCertification || val?.producerCpcbCertification
      updatedForm.certificateNumber.hidden = !showCert
      updatedForm.certificateDetails.hidden = !showCert
    }

    if (e?.businessName) {
      businessNameCheck(e?.businessName)
    }

    if (
      include(
        [
          'pincode',
          'state',
          'city',
          'country',
          'recyclerRvsfCertification',
          'producerCpcbCertification',
        ],
        currentKey,
      ) ||
      val?.materialProducerMaterialTypes
    ) {
      setUserForm(updatedForm)
      form.setFieldsValue(updatedFormData)
    }
  }

  const updateProfile = async () => {
    const pathName = location.pathname.split('/')
    if (isEqual(editInfo?.data?.id, loginUserId)) {
      const profileResponse = await getUserProfileApi({
        id: editInfo?.data?.id,
      })
      if (profileResponse?.data?.data) {
        dispatch(profileDetails(profileResponse?.data?.data))
        setItem('userData', JSON.stringify(profileResponse?.data?.data))
      }
    }
    if (isEqual(`/${pathName?.[1]}`, USER_TXT)) {
      navigate(`${USER_TXT}/${userType}`, {
        state: { renderUserAPI: true },
      })
    }
    setLoader(false)

    notifyMethod.success({ message: 'msg_UserUpdatedSuccessfully' })
    form.resetFields()
    editInfo?.flag && handleCancelEdit()
  }

  const createEmailPayload = (emailArr = []) => {
    return emailArr.reduce(
      (obj, email, index) => ({
        ...obj,
        [`emailId${index ? index : ''}`]: email,
      }),
      { emailId: '' },
    )
  }
  const filePayload = async (file, key) => {
    if (!file?.originFileObj)
      return {
        [`${key}Url`]: null,
        [`${key}Name`]: null,
      }
    return {
      [`${key}Url`]: await getBase64(file?.originFileObj),
      [`${key}Name`]: file?.originFileObj?.name,
    }
  }

  const certUploadApiCall = async file => {
    if (!file?.originFileObj) return null
    const formData = new FormData()
    formData.append('file', file?.originFileObj)
    const resp = await getImageFileApi({
      params: '?source=USER',
      payload: formData,
    })

    return resp?.data?.dmsId
  }

  const onFinish = async () => {
    let data = form.getFieldValue()
    const emailObj = createEmailPayload(data?.emailId)
    data = { ...data, ...emailObj }
    if (isEqual(consumer, formRoleId)) {
      data.company = isEqual(data.consumerType, 'company')
      data.individual = isEqual(data.consumerType, 'individual')
      delete data.consumerType
    }

    if (isEqual(recycler, formRoleId)) {
      const dateFields = [
        'recyclerAirActDate',
        'recyclerWaterActDate',
        'recyclerAuthorisationValidityDate',
        'recyclerCertificationValidityDate',
      ]
      dateFields.forEach(fieldKey => {
        data[fieldKey] = ternary(
          data[fieldKey],
          data?.[fieldKey]?.format('DD/MM/YYYY'),
          '',
        )
      })
    }

    if (include([refurbisher, supplier], formRoleId)) {
      if (data?.materialProducerMaterialTypes) {
        data.materialProducerMaterialTypes = [
          data?.materialProducerMaterialTypes,
        ]?.map(item => ({
          ...data?.machineDetails?.[item],
          materialTypeId: item,
        }))

        delete data.machineDetails
      }
      if (isEqual(refurbisher, formRoleId)) {
        data.otherDoableJobs =
          data?.otherDoableJobs?.map(
            item =>
              refurbisherOpt?.jobTag?.find(opt => isEqual(opt?.key, item))?.id,
          ) || []
      }
    }

    if (editInfo?.data?.id) {
      if (isBuilding) {
        const payload = {
          userId: editInfo?.data?.userId,
          consumerId: editInfo?.data?.userId,
          id: editInfo?.data?.id,
          country: editInfo?.data?.country,
          ...data,
        }
        setLoader(true)
        const response = await updateBuildingApi({ payload })
        setLoader(false)
        if (response?.data?.data) {
          apiCall && apiCall({ pageNo: 1 })
          notifyMethod.success({
            message: 'msg_BuildingUpdatedSuccessfully',
          })
          setEditInfo({ flag: false, data: {} })
        }
      } else {
        setLoader(true)
        const payload = {
          userId: editInfo?.data?.id,
          country: editInfo?.data?.country,
        }
        keys(data).forEach(k => {
          if (include(k, ['profile', 'certificateDetails'])) return
          if (isEqual('materialProducerMaterialTypes', k)) {
            const prevMaterialType = initialEditData.current?.[k]
            const currentMaterialType = data?.[k]?.[0]?.materialTypeId
            const removedMaterialType = prevMaterialType
              ?.filter(item =>
                notEqual(currentMaterialType, item?.materialTypeId),
              )
              ?.map(({ materialTypeId }) => materialTypeId)
            payload.removedMaterialTypes = removedMaterialType
            payload[k] = data?.[k]
          } else if (include(k, 'emailId')) {
            if (notEqual(k, 'emailId')) return
            Array.from({ length: 11 }, (v, i) => `emailId${i || ''}`).forEach(
              elem => {
                if (!editInfo?.data?.[elem]) {
                  payload[elem] = data?.[elem]
                } else {
                  if (notEqual(editInfo?.data?.[elem], data?.[elem])) {
                    payload[elem] = data?.[elem] ?? ''
                  }
                }
              },
            )
          } else if (include(['selectionFunctionality'], k)) {
            // send in payload all time
            payload[k] = data?.[k]
          } else if (include(['locationChannelRequestDtos'], k)) {
            const locationIds = []
            const ids = []

            const selectedLocation = editInfo?.data?.userLocationChannelDtos
            const currentLocation = data?.locationChannelRequestDtos

            selectedLocation?.forEach((value, index) => {
              if (currentLocation?.[index]?.locationId !== value?.locationId) {
                locationIds.push(value?.locationId)
              }
              value?.channels?.forEach(channel => {
                if (
                  !currentLocation?.[index]?.channelIds?.includes(
                    channel?.channelId,
                  )
                ) {
                  ids.push(channel.id)
                }
              })
            })
            payload[k] = data?.[k]?.map((item, index) => {
              const channelIds = selectedLocation?.[index]?.channels?.map(
                channel => channel?.channelId,
              )
              return {
                ...item,
                channelIds: item.channelIds?.filter(
                  value => !include(channelIds, value) && value,
                ),
              }
            })
            payload.locationIds = locationIds
            payload.ids = ids
          } else if (isEqual('sameAsParentBtn', k)) {
          } else if (include(['modelNames'], k) && !data?.[k]) {
            // don't send key to backend if no value
            return
          } else if (notEqual(data?.[k], editInfo?.data?.[k])) {
            payload[k] = data?.[k] ?? '-1' // -1 for removing or empty field value while editing
          }
        })

        if (
          data?.profile?.fileList?.[0] &&
          notEqual(
            editInfo?.data?.profile?.fileUrl,
            data?.profile?.fileList?.[0]?.url,
          )
        ) {
          Object.assign(
            payload,
            await filePayload(data?.profile?.fileList?.[0], 'profile'),
          )
        } else if (
          !data?.profile?.fileList?.[0] &&
          editInfo?.data?.profile?.fileUrl
        ) {
          //when removing a profile
          Object.assign(payload, { profileName: null, profileUrl: -1 })
        }
        if (
          data?.certificateDetails?.fileList?.[0] &&
          notEqual(
            editInfo?.data?.certificateDetails?.fileUrl,
            data?.certificateDetails?.fileList?.[0]?.url,
          )
        ) {
          payload.certificateDmsId = await certUploadApiCall(
            data?.certificateDetails?.fileList?.[0],
          )
        }

        //remove unnecessary payload
        delete payload.profile
        delete payload.certificateDetails

        if (length(keys(payload)) > 2) {
          const response = await updateUserApi({
            payload,
          })
          if (response?.data?.data?.success) {
            await updateProfile()
          }
        } else {
          handleCancelEdit && handleCancelEdit()
        }
        setLoader(false)
      }
    } else {
      if (isBuilding) {
        const payload = {
          userId: selectedUserDetails?.id,
          ...data,
        }
        setLoader(true)
        const response = await addNewBuildingApi({ payload })
        setLoader(false)
        if (response?.data?.data) {
          notifyMethod.success({ message: 'msg_BuildingAddedSuccessfully' })
          setEditInfo({ flag: false, data: {} })
          apiCall && apiCall({ pageNo: 1 })
          addNewBuildData &&
            addNewBuildData({ newBuilding: response?.data?.data?.building })
        }
      } else {
        if (isSelect || selectUser?.data?.id) {
          setLoader(true)
          const userData = getItem('userData')
            ? JSON.parse(getItem('userData'))
            : null
          const payload = {
            ...data,
            forRoleId: formRoleId,
            forUserId: currentUserDescription?.parent
              ? selectUser?.data?.id
              : userData?.id,
            ...(length(data?.profile?.fileList)
              ? await filePayload(data?.profile?.fileList?.[0], 'profile')
              : {}),
          }
          if (length(payload?.certificateDetails?.fileList)) {
            payload.certificateDmsId = await certUploadApiCall(
              payload?.certificateDetails?.fileList?.[0],
            )
          }

          //remove unnecessary properties
          delete payload.profile
          delete payload.certificateDetails

          const response = await addNewUserApi({ payload })
          setLoader(false)
          if (response?.data?.data?.success) {
            userType && navigate(`${USER_TXT}/${userType}`)
            successCallback && successCallback(response?.data?.data?.userInfo)
            // set success or failure message
            notifyMethod.success({ message: 'msg_UserAddedSuccessfully' })
          }
        } else {
          notifyMethod.warning({ message: 'msg_SelectUser' })
        }
      }
    }
  }

  const handleSelectClick = async () => {
    setSelectUser({
      ...selectUser,
      list: notEqual(selectUser?.list?.pageNo, 1)
        ? await getUsers({ page: 1 })
        : selectUser?.list,
      flag: true,
    })
  }

  const handleSelectCancel = () => {
    setSelectUser({ ...selectUser, flag: false })
  }

  const getUsers = async ({ page }) => {
    let params = `${page}?roleId=${currentUserDescription?.parent?.id}`

    if (userWiseDepartment?.[formRoleId]) {
      params += `&department=${userWiseDepartment?.[formRoleId]}`
    }

    const response = await getUserList({
      params,
    })
    return await response?.data
  }

  const handleTableChange = async pagination => {
    const { current } = pagination
    setSelectUser({ ...selectUser, list: await getUsers({ page: current }) })
  }

  const onSelectUser = data => {
    if (length(data)) {
      setSelectUser({ ...selectUser, data: data?.[0], flag: false })
    } else {
      notifyMethod.warning({ message: 'msg_SelectUser' })
    }
  }

  const handleClosePopup = () => {
    setPopup({ open: false, message: '' })
  }

  const handleSameAsParent = (parentData = {}) => {
    // const getEmailList = data => {
    //   const emailList = []
    //   entries(data)?.forEach(([key, value]) => {
    //     if (include(key, 'emailId') && value) {
    //       emailList.push(value)
    //     }
    //   })
    //   return ternary(length(emailList), emailList, [''])
    // }

    const dataList = [
      'pincode',
      'state',
      'city',
      'country',
      'address',
      // 'emailId',
    ]
    const data = {
      name: parentData?.businessName,
      contact: parentData?.phoneNumber,
    }
    if (
      !editInfo?.data?.id &&
      include(
        [
          dataEntry,
          categoryUser,
          salesUser,
          operationsUser,
          scrappingFacilityEntryUser,
        ],
        formRoleId,
      )
    ) {
      dataList.push('departmentName')
    }

    dataList.forEach(value => {
      /*       if (isEqual(value, 'emailId')) {
        data[value] = getEmailList(parentData)
      } else  */ data[value] = parentData?.[value]
    })

    setUserForm(prev => {
      const tempForm = { ...prev }
      tempForm.pincode = {
        ...tempForm.pincode,
        options: pincodeOptions,
      }
      tempForm.city = {
        ...tempForm.city,
        options: cityOptions,
      }
      tempForm.state = {
        ...tempForm.state,
        options: stateOptions,
      }
      return tempForm
    })

    form.setFieldsValue(data)
  }

  const getAddressData = ({ currentAddress, googleAddress }) => {
    if (currentAddress || googleAddress) {
      setCurrentAddress(currentAddress)
      form.setFieldsValue({
        ...form.getFieldsValue(),
        ...(currentAddress && {
          address: currentAddress,
        }),
        ...(googleAddress && {
          pincode: googleAddress?.pincode,
          city: googleAddress?.city,
          state: googleAddress?.state,
          country: googleAddress?.country,
        }),
      })
    }
    // setUserForm(prev => {
    //   prev.pincode = { ...prev.pincode, disabled: googleAddress?.pincode }
    //   return prev
    // })
  }

  return {
    form,
    userForm,
    handleValuesChange,
    onFinish,
    currentUserDescription,
    handleSelectClick,
    selectUser,
    handleSelectCancel,
    handleTableChange,
    onSelectUser,
    isSelect,
    loader,
    popup,
    formRoleId,
    handleClosePopup,
    handleSameAsParent,
    getAddressData,
    currentAddress,
  }
}

export default addUser
